import { useTranslation } from 'react-i18next';
import Form from 'react-bootstrap/Form';
import { Typography } from 'app/components/ui';
import { useUpdateTag } from 'entities/tag';

interface HiddenSwitchProps {
  tagId: string;
  documentSuperId: number;
  currentHiddenValue: boolean;
  snapshotValue: string;
  isPlaced: boolean;
  disabled?: boolean;
}

export const HiddenSwitch = ({ tagId, documentSuperId, currentHiddenValue, snapshotValue, isPlaced, disabled = false }: HiddenSwitchProps) => {
  const { t } = useTranslation('tag');

  const { mutate: updateTag } = useUpdateTag();

  const handleUpdate = (hidden: boolean) => {
    if (hidden) {
      updateTag({ id: tagId, documentSuperId, hidden: true, value: snapshotValue });
    } else {
      updateTag({ id: tagId, documentSuperId, hidden: false });
    }
  };

  const lockedUnplaced = currentHiddenValue && !isPlaced;

  return (
    <div className="property-row">
      <Typography fontWeight="semibold" className="property-label">
        {t('hidden.title')}
      </Typography>
      <Form.Check
        type="switch"
        id={`hidden-switch-${tagId}`}
        checked={currentHiddenValue}
        onChange={(e) => handleUpdate(e.target.checked)}
        disabled={disabled || lockedUnplaced}
        style={disabled || lockedUnplaced ? { cursor: 'not-allowed' } : undefined}
      />
    </div>
  );
};
